import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import { reducer as notifications } from 'react-notification-system-redux';

import app from './app';
import i18n from './locale';
import growl from './notifications';
import account from './account';

const schedulingApp = combineReducers({
  app,
  form,
  notifications,
  i18n,
  growl,
  account,
});

export default schedulingApp;
